import * as styles from './howSendItSelector.module.scss';

type HowSendItSelectorProps = {
  notDeliveryByEmail: boolean;
  onSelect: (value: boolean) => void;
};

const HowSendItSelector = ({ notDeliveryByEmail = false, onSelect }: HowSendItSelectorProps) => (
  <div className={styles.container}>
    <label
      key="delivery-by-email-label"
      className={styles['checkContainer']}
      htmlFor="delivery-by-email"
    >
      Email gift card to my friend (Delivered immediately)
      <input
        key="delivery-by-email-input"
        data-testid="delivery-by-email-input"
        type="radio"
        name="radio"
        id="delivery-by-email"
        defaultChecked={!notDeliveryByEmail}
        onClick={() => {
          onSelect(false);
        }}
      />
      <span key="delivery-by-email-span" className={styles.check} />
    </label>
    <label
      key="not-delivery-by-email-label"
      className={styles['checkContainer']}
      htmlFor="not-delivery-by-email"
    >
      It’s a surprise! Email me the gift card, and I’ll print or send it myself.
      <input
        key="not-delivery-by-email-input"
        data-testid="not-delivery-by-email-input"
        type="radio"
        name="radio"
        id="not-delivery-by-email"
        defaultChecked={notDeliveryByEmail}
        onClick={() => {
          onSelect(true);
        }}
      />
      <span key="not-delivery-by-email-span" className={styles.check} />
    </label>
  </div>
);

export default HowSendItSelector;
